import { Box, Grid, Typography, useMediaQuery, useTheme } from '@mui/material'
import React from 'react'
import { useNavigate } from 'react-router-dom'
import Buttons from '../Components/Buttons'
import { ROUTER } from '../router/constants'
import { convertToPersianNumber } from '../helpers/convertToPersianNumbers'

const ReservationConfirmation = () => {

    const theme = useTheme()
    const isLargeScreen = useMediaQuery(theme.breakpoints.up('lg'))

    const navigate = useNavigate()



    const handleReserveConfirm = () => {
        navigate(ROUTER.SETTING)
    }


    let time  = localStorage.getItem('selectedTime')
    let dayOfWeek  = localStorage.getItem('selectedWeekday')
    let date  = localStorage.getItem('completeDate')

    return (
        <div className='container' style={{ padding: isLargeScreen ? '60px 40px' : '30px 20px', backgroundColor: 'white', borderRadius: '10px', boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -4px rgba(0, 0, 0, 0.1)' }}>
            <Typography variant={isLargeScreen ? 'h1' : 'h2'} align="center" color='black' sx={{ fontWeight: isLargeScreen ? 600 : 700, color: 'black', mb: '64px' }}>
                تاييد رزرو
            </Typography>
            <Box sx={{ mb: "64px" }}>
                <Typography
                    color={theme.palette.info.dark}
                    variant={isLargeScreen ? 'h5' : 'h6'}
                    align="center"
                    mb={'24px'}
                >
                    لطفا اطلاعات رزرو خود را بررسى نماييد
                </Typography>
                <Grid>
                    <Grid display={'flex'} alignItems={'center'} justifyContent={'center'} gap={'4px'} mb={'8px'}>
                        <Typography variant={isLargeScreen ? 'h4' : 'h5'} fontWeight={700} color='black'>{`${dayOfWeek} ،`}</Typography>
                        <Typography variant={isLargeScreen ? 'h4' : 'h5'} fontWeight={700} color='black'>{convertToPersianNumber(date)}</Typography>
                    </Grid>
                    <Grid display={'flex'} alignItems={'center'} justifyContent={'center'} gap={'4px'}>
                        <Typography variant={isLargeScreen ? 'h4' : 'h5'} fontWeight={700} color={theme.palette.info.dark}>{'ساعت : '}</Typography>
                        <Typography variant={isLargeScreen ? 'h4' : 'h5'} fontWeight={700} color='black'>{convertToPersianNumber(time)}</Typography>
                    </Grid>
                </Grid>
            </Box>
            <Buttons backTitle={'بازگشت'} checkTitle={'ثبت'} backLink={ROUTER.RESERVE_ROOM_TIME} checkLink={''} onCheck={handleReserveConfirm} />
        </div>
    )
}

export default ReservationConfirmation
